export default __webpack_public_path__ + "static/media/cabinet-builder.dcc8e824.png";